<template>
    <div class="cs-input-text">
    <input
        class="cs-input"
        :modelValue="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        :type="inputType"
        :id="inputID"
        :placeholder="placeHolder"
    />
    </div>
</template>

<script>

export default {
    name: 'csInputText',
    props: {
        inputType: {
            type: String,
            required: true
        },
        inputID: {
            type: String,
            required: true
        },
        modelValue: String,
        placeHolder: {
            type: String,
            required: false
        }
    },
    emits: [
        'update:modelValue'
    ]
}
</script>


<style scoped>
 @import './inputText.css';
</style>